<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection>
        </MetaSection>
      </GridCol>
      <GridCol :size="12">
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :size="7">
                <div class="d-flex align-items-center justify-content-start gap-2">
                  <div class="d-flex justify-content-start w-100 gap-2">
                    <InputGroup class="m-0 filter">
                      <template v-slot:prepend>
                        <i class="fas fa-search" aria-hidden="true"></i>
                      </template>
                      <input v-model="params.keyword" @keyup="getData(params.keyword)" type="text" class="form-control"
                        placeholder="Cari nama jabatan" style="border-right: 1px solid #d2d6da!important;">
                    </InputGroup>

                    <FormGroup class="m-0 filter">
                      <model-list-select
                        class="form-control"
                        v-model="params.periode_id"
                        :list="
                          list_periode.sort((a, b) => a.name.localeCompare(b.name))
                        "
                        option-value="id"
                        option-text="name"
                        placeholder="Semua Periode"
                      />
                    </FormGroup>

                    <FormGroup class="m-0 filter">
                      <model-list-select
                        class="form-control"
                        v-model="params.unitkerja_id"
                        :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
                        option-value="id"
                        option-text="name"
                        placeholder="Semua Unit Kerja"
                      />
                    </FormGroup>

                    <FormGroup class="m-0 filter">
                      <model-list-select
                        class="form-control"
                        v-model="params.status"
                        :list="[{text: 'Aktif', value: 1}, {text: 'Non Aktif', value: 0}]"
                        option-value="value"
                        option-text="text"
                        placeholder="Semua Status"
                      />
                    </FormGroup>
                  </div>
                  <FormGroup class="m-0">
                      <ArgonButton :disabled="buttonExcelDisabled" @click="convertToCSV" type="button">
                          Excel
                      </ArgonButton>
                  </FormGroup>
                </div>
              </GridCol>
            </GridRow>
          </template>
          <ListView :thead="['NIP', 'Nama Pegawai', 'Unit Kerja', 'Nilai AKhir', 'Jabatan', 'Indeks Penilaian', 'Catatan']">
            <template v-slot:tbody>
              <tr v-if="data.length < 1">
                <td colspan="7" class="text-center text-secondary">Tidak ada data</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td>{{ item.nip || "-" }}</td>
                <td class="font-weight-bold">{{ item.name || "-" }}</td>
                <td>{{ item?.unitkerja ? (item?.unitkerja?.length > 40 ? item?.unitkerja?.slice(0, 40) + "..." : item?.unitkerja) : "-" }}</td>
                <td>{{ item?.nilai_akhir || "-" }}</td>
                <td>{{ item?.jabatan ? (item?.jabatan?.length > 40 ? item?.jabatan?.slice(0, 40) + "..." : item?.jabatan) : "-" }}</td>
                <td>{{ item?.indeks_penilaian || "-" }}</td>
                <td>{{ item?.catatan || "-" }}</td>
              </tr>
            </template>
            <ArgonPagination :page="params.page" :total_page="metaData.total_page" :current_page="metaData.current_page" @changepage="changePage" @changelimit="changeLimit" />
          </ListView>
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import LaporanSummaryApi from '@/repository/api/LaporanSummaryApi';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import MetaSection from '@/components/MetaSection.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
import ListView from '@/components/ListView.vue';
import FormGroup from '@/components/FormGroup.vue';
import ArgonPagination from '@/components/ArgonPagination.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";

export default {
  name: "tables",
  components: {
    CardComponent,
    InputGroup,
    MetaSection,
    GridRow,
    GridCol,
    ListView,
    FormGroup,
    ArgonPagination,
    ArgonButton,
    ModelListSelect,
  },
  data() {
    return {
      timer: undefined,
      data: [],
      unitkerja: [],
      list_periode: [],
      params: {
        limit: "",
        jabatan_id: "",
        unitkerja_id: "",
        periode_id: "",
        status: "",
        keyword: "",
        page: 1,
      },
      metaData: {},
      buttonExcelDisabled: false,
      downloadExcelState: 1,
    };
  },
  async mounted() {
    this.getPeriode();
    await this.getData();
    await this.getUnitKerja();
  },
  watch: {
    'params.periode_id': {
      handler: async function () {
        await this.getData();
      },
      deep: true,
    },
    'params.status': {
      handler: async function () {
        await this.getData();
      }
    },
    'params.unitkerja_id': {
      handler: async function () {
        this.getData();
      }
    },
    'params.limit': {
      handler: async function () {
        this.params.page = 1
        await this.getData();
      },
      deep: false,
    },
    'params.page': {
      handler: async function (newVal, oldVal) {
        if (newVal < 1) {
          this.params.page = oldVal
        }
        else {
          // await this.getJabatan();
          await this.getData();
        }
      },
      deep: false,
    },
  },
  methods: {
    convertToCSV() {
      if (this.downloadExcelState == 1) {
        this.downloadExcelState = 0;
        this.buttonExcelDisabled = true;
        const csvData = this.convertJSONToCSV(this.data.map((item) => {
          return {
            'nip': item?.nip ?? '',
            'name': item?.name ?? '',
            'unitkerja': item?.unitkerja ?? '',
            'nilai_akhir': item?.nilai_akhir ?? '',
            'jabatan': item?.jabatan ?? '',
            'indeks_penilaian': item?.indeks_penilaian ?? '',
            'catatan': item?.catatan ?? ''
          }
        }));
        this.downloadCSV(csvData, 'Laporan Summary.csv');
        setTimeout(() => {
          this.buttonExcelDisabled = false;
          this.downloadExcelState = 1;
        }, 5000);
      }
    },
    convertJSONToCSV(jsonData) {
      const headers = Object.keys(jsonData[0]);
      const csvRows = [];

      csvRows.push(headers.join(','));

      jsonData.forEach((row) => {
        const values = headers.map((header) => {
          const value = row[header];
          return JSON.stringify(value);
        });
        csvRows.push(values.join(','));
      });

      return csvRows.join('\n');
    },
    downloadCSV(csvData, filename) {
      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    changeLimit(limit) {
      this.params.limit = limit
    },
    changePage(page) {
      this.params.page = page
    },
    async getPeriode() {
      await KpiPeriodeApi.getbyparam({ page: "all", status: "active" })
        .then((response) => {
          this.list_periode = response?.data;
          // this.params.periode_id = this.list_periode?.[0]?.id || '';
        })
        .catch(() => {
          this.list_periode = [];
        });
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.getbyparam({page: "all", status: "active"}).then((response) => {
        this.unitkerja = response.data;
      }).catch(() => {
        this.unitkerja = [];
      });
      this.$store.state.loading = false;
    },
    async getData(keyword = "") {
      clearTimeout(this.timer)
      if (keyword.length <= 0) {
        await this.getDataAll();
      }
      else if (keyword.length >= 2) {
        this.timer = setTimeout(async () => {
          await this.getDataAll();
        }, 1500)
      }
    },
    async getDataAll() {
      let params = {}
      Object.keys(this.params).forEach(key => {
        if (!(this.params[key] === undefined || this.params[key] === null || this.params[key] === "")) {
          params[key] = this.params[key];
        }
      });
      this.$store.state.loading = true;
      await LaporanSummaryApi.getbyparam(params).then((response) => {
        this.data = response.data;
        this.metaData = {
          status: response?.status ?? null,
          message: response?.message ?? null,
          total_item: response?.total_item ?? null,
          per_page: response?.per_page ?? null,
          total_page: response?.total_page ?? null,
          current_page: response?.current_page ?? null,
        }
      }).catch((error) => {
        if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
          this.params.page = this.params.page - 1;
        }
        this.metaData = {};
        this.data = [];
      });
      this.$store.state.loading = false;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await LaporanSummaryApi.delete(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error?.response?.data?.message ?? "Data tidak dapat dihapus",
            });
          });
          this.$store.state.loading = false;
        }
      })
    }
  },
};
</script>
